import { useNavigate } from '@tanstack/react-router';
import { ListsOverviewScreen } from '@mrrmlab/feature-lists';

export function TodoRoute() {
  const navigate = useNavigate();
  return (
    <ListsOverviewScreen
      typeFilter="todo"
      onOpenList={(list) =>
        navigate({ to: '/lists/$listId', params: { listId: list.id } })
      }
    />
  );
}
